@if (componentData.data$ | async; as component) {
  @if (component?.isCartUsp) {
    <div>
      <div class="container" [ngClass]="getDirection(component.direction)">
        <div class="row">
          <div class="col col-usp-cart">
            <div class="usp cart">
              <h2>{{ 'addToCart.cart.quotesTitle' | transloco }}</h2>
              <div class="usp-inner" boelsInjectIcon>
                <ul>
                  <li>
                    {{ 'addToCart.cart.quotes.node1' | transloco }}
                  </li>
                  <li>
                    {{ 'addToCart.cart.quotes.node2' | transloco }}
                  </li>
                  <li>
                    {{ 'addToCart.cart.quotes.node3' | transloco }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div [ngClass]="{ 'background--dark': isHorizontal() }">
      <div class="container" [ngClass]="getDirection(component.direction)">
        <div class="row">
          <div class="col">
            <div class="usp">
              <div
                class="usp-inner"
                [innerHtml]="component?.content | safeHtml"
                boelsInjectIcon
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
